module.exports = __webpack_public_path__ + "img/home_4.f7c7779a.png";